import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import * as utils from './Utils';



export function formatCartItem(itemRow) {
  let item = {};
  item['id'] = `${itemRow.key}`;
  item['title'] = itemRow.title;
  item['quantity'] = itemRow.quantity;
  item['price'] = itemRow.price;
  item['product_id'] = `${itemRow.product_id}`;
  item['product_title'] = itemRow.product_name;
  item['variant_id'] = `${itemRow.variation_id}`;
  item['variant_title'] = itemRow.variation_name;
  return item;
}

export function formatCartResponse(response) {
  let data = {};
  data['currency'] = response.currency;
  data['total_price'] = response.subtotal;
  data['total_discount'] = response.discount_total;

  let items = [];
  response.items.forEach((itemRow) => {
    let item = formatCartItem(itemRow);
    items.push(item);
  })

  data['items'] = items;
  return data;
}


function getAddedCartItems(response) {
  const existingData = get(window.OnVoardEventsData, 'woocommerce_cart', {});

  const existingMapper = {};
  if (existingData.items) {
    existingData.items.forEach((itemRow) => {
      existingMapper[`${itemRow.key}`] = parseInt(itemRow.quantity);
    })
  }

  const currentMapper = {};
  if (response.items) {
    response.items.forEach((itemRow) => {
      currentMapper[`${itemRow.key}`] = parseInt(itemRow.quantity);
    })
  }

  let addedIds = utils.getAddedCartItemIds(existingMapper, currentMapper);
  let addedItems = [];
  if (response.items) {
    response.items.forEach((itemRow) => {
      let itemId = `${itemRow.key}`;
      if (!addedIds.includes(itemId)) return;
      addedItems.push(itemRow)
    })
  }

  return addedItems;
}

export function handleCartUpdate(response) {
  let noChange = isEqual(window.OnVoardEventsData['woocommerce_cart'], response);
  let isNew = !window.OnVoardEventsData['woocommerce_cart'] ? true : false;

  // no cart change
  if (noChange) return;

  // if first time loading, don't dispatch added cart items
  let addedCartItems = [];
  if (!isNew) addedCartItems = getAddedCartItems(response);

  window.OnVoardEventsData['woocommerce_cart'] = response;
  utils.dispatchCartUpdateEvent(response);
  addedCartItems.forEach((item) => {
    utils.dispatchAddCartItemEvent(item);
  })
}

export function setupCartUpdateEvent() {
  if (window.OnVoardEventsData.setupCartUpdateEvent) return;
  window.OnVoardEventsData.setupCartUpdateEvent = true;
  if (typeof jQuery === 'undefined') return;

  let triggerCartUpdate = () => {
    utils.getRq({
      "url": "/wp-json/onvoard/get-cart",
      "headers": {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "x-requested-with": "XMLHttpRequest",
      },
      "successCallback": (response) => {
        response = utils.parseResponse(response);
        if (!response) return;
        if (response.status === 'error') return;
        handleCartUpdate(response);
      },
      "errorCallback": () => {}
    });
  };

  let cartEvents = [
    "added_to_cart",
    "removed_from_cart",
    "updated_cart_totals",
  ];

  jQuery(function($) {
    cartEvents.forEach((cartEvent) => {
      $(document.body).on(cartEvent, () => {
        triggerCartUpdate();
      });
    })
  });
}

export function loadCart() {
  let successCallback = (response) => {
    response = utils.parseResponse(response);
    if (!response) return;
    if (response.status === 'error') return;
    handleCartUpdate(response);
  };

  let errorCallback = () => {};

  utils.getRq({
    "url": "/wp-json/onvoard/get-cart",
    "headers": {
      "Accept": "application/json",
      "Content-Type": "application/json",
      "x-requested-with": "XMLHttpRequest",
    },
    "successCallback": successCallback,
    "errorCallback": errorCallback,
  });
}

